import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withTranslate } from "react-redux-multilingual";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
  getCurrentLanguage,
  setCurrentLanguage,
  setCurrencySymbol,
} from "../../../store";
import { postCall, getCall } from "../../../api/post";
import { confirmAlert } from "react-confirm-alert";
import {
  getMerchantInformationUrl,
  getMasterDetailsIdUrl,
  getTenantInfoUrl,
  getProductSearchUrl,
} from "../../../services";
import { isInquiryOrCart, isUserAllowedToRegister } from "../../../actions";
import { connect } from "react-redux";
import ConfirmAlertPopup from "../../../Alert/ConfirmAlertPopup";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import LogoutAnim from "../../../animation/AnimFiles/LogoutAnim";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import CartContainer from "../../../containers/CartContainer";
import CompareContainer from "../../../containers/CompareContainer";
import LogoImage from "../header/logo";
import { setHeaderCounters } from "../../../actions"; // add this import
import axios from "axios"; // Add this at the top with other imports

const imageStyle = {
  padding: "10px",
  height: "45px",
  width: "45px",
};

const pStyle = {
  display: "contents",
  textAlign: "center",
  fontSize: "20px",
  padding: "30px",
};

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
  }
  state = {
    isMyAccountVisible: false,
    contactUs: {},
    AppTitle: "",
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    masterDetailsObj: {},
    isShowChangeLanguageModalPopUp: false,
    divName: "LTR", // Always LTR for English
    currentLanguage: "en", // Always English
    isSearchOptionVisible: false,
    productList: null,
    userDetails: loadUserDetailsFromLocalStorage(),
    headerCounters: {
      cart_count: 0,
      wishlist_count: 0,
      comparison_count: 0,
      reward_points: 0,
    },
    showQrModal: false,
    qrCodeUrl: "",
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    console.log("User Details:", userDetails);
    if (userDetails === undefined) {
      this.setState({ isMyAccountVisible: true });
    } else {
      this.setState({ isMyAccountVisible: false });
    }
    this.fetchHeaderCounters();
  }

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        // handle error if needed
        return;
      }
      this.setState({ headerCounters: response });
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {
      // handle error if needed
    }
  };

  logout = async () => {
    const logoutUrl = "users/logout";
    const logOut = await postCall(logoutUrl, {});

    if (logOut.error) {
      clearLocalStorageReload({ response: logOut });
      this.loadErrorMessageAnimation(logOut.error.message);
    } else {
      removeUserDetailAndOtherDetails();
      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject("str_you_are_successfully_logged_out")
          ? getValueFromLanguageObject("str_you_are_successfully_logged_out")
          : "You are successfully logged out!"
      );
      setTimeout(() => {
        this.props.history.push("/login");
        window.location.reload();
      }, 100);
    }
  };

  initContactUs = async () => {
    const { masterDetailsObj } = this.state;
    const contantusUrl = getMerchantInformationUrl(masterDetailsObj);
    const contactUs = await getCall(contantusUrl, []);
    if (contactUs.error) {
      clearLocalStorageReload({ response: contactUs });
      this.loadErrorMessageAnimation(contactUs.error.message);
      if (contactUs.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        // this.props.history.push("/login");
        return;
      }
    } else {
      this.setState({ contactUs, AppTitle: contactUs.companyname });
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  renderNotificationIcon = () => {
    const {
      notificationCounter,
      handleNotificicationDrawer,
      isInquiry,
    } = this.props;

    return (
      <li
        className={`cart_sign_in mobile-menu mobile-notification ${
          !isInquiry ? "" : "hide-settings-notification"
        }`}
        onClick={() => {
          handleNotificicationDrawer();
        }}
        style={{ marginRight: "15px" }}
      >
        <div>
          {/* <img
            src={`${process.env.PUBLIC_URL}/assets/images/icon/bell.png`}
            className="img-fluid"
            alt=""
          /> */}
          <i class="fa fa-bell" aria-hidden="true" />
        </div>
        <div className="cart-qty-cls">{notificationCounter}</div>
      </li>
    );
  };

  renderSearchBar = () => {
    const { isProductListDropDownVisible, productList, searchValue } =
      this.state || {};
    // let isSearchOptionVisible = false;
    // const pageNameFromUrl = window.location.pathname.split("/")[2];
    // if (pageNameFromUrl === "") {
    //   isSearchOptionVisible = true;
    // } else if (pageNameFromUrl === "products") {
    //   isSearchOptionVisible = true;
    // } else if (pageNameFromUrl === "requestproduct") {
    //   isSearchOptionVisible = true;
    // } else if (pageNameFromUrl === "collection") {
    //   isSearchOptionVisible = true;
    // } else if (pageNameFromUrl === "cart") {
    //   isSearchOptionVisible = true;
    // }
    return (
      <>
        {/* {isSearchOptionVisible && ( */}
        <div class="search_bar_top">
          <div class="header_search_bar">
            <div className="search-bar-group">
              <span className="search-addon">
                <i
                  class="fa fa-search"
                  aria-hidden="true"
                  style={{ fontSize: "12px" }}
                />
              </span>
              <input
                class="form-control"
                id="search_product"
                name="search_product"
                type="What are you looking for?"
                placeholder={
                  getValueFromLanguageObject(
                    "str_which_product_you_are_looking_for"
                  )
                    ? getValueFromLanguageObject(
                        "str_which_product_you_are_looking_for"
                      )
                    : "which product you are looking for?"
                }
                aria-label="What are you looking for?"
                value={searchValue}
                onChange={(e) => {
                  this.setState({ productList: null });
                  this.onSearchProduct(e.target.value);
                }}
              />
            </div>
            {searchValue && productList && isProductListDropDownVisible && (
              <div className="typehead-search">
                <div className="inner-search">
                  {productList &&
                    productList.map((product, index) => (
                      <Link
                        to={`/singleproduct/${product.id}`}
                        onClick={() => {
                          this.setState({
                            isProductListDropDownVisible: false,
                            searchValue: product.name,
                          });
                        }}
                      >
                        <div className="search-item">{product.name}</div>
                      </Link>
                    ))}
                </div>
              </div>
            )}
            {searchValue &&
              productList &&
              productList.length === 0 &&
              !isProductListDropDownVisible && (
                <div className="typehead-search">
                  <div className="inner-search">
                    <div className="search-item">
                      {getValueFromLanguageObject("str_no_products_found")
                        ? getValueFromLanguageObject("str_no_products_found")
                        : "No Products Found"}
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        {/* )} */}
      </>
    );
  };

  onSearchProduct = (value) => {
    this.setState({ searchValue: value });
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.initProductList();
    }, 1000);
  };

  initProductList = async () => {
    try {
      const { searchValue } = this.state;
      const productListUrl = getProductSearchUrl(searchValue);
      const products = await getCall(productListUrl, []);

      if (products.error) {
        clearLocalStorageReload({ response: products });
        this.loadErrorMessageAnimation(products.error.message);
        if (products.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        if (products && products.length > 0) {
          this.setState({ isProductListDropDownVisible: true });
        } else {
          this.setState({ isProductListDropDownVisible: false });
        }
        this.setState({ productList: products });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  handleDownloadAppClick = async () => {
    this.setState({ showQrModal: true, qrCodeUrl: "" });
    try {
      const response = await axios.get("https://rezrewardspython.secretdemo.com/api/v2/products/getqrcode", {
        responseType: "blob", // Important for binary image data
        withCredentials: true, // If you need to send cookies/session
        headers: {
          // You can add custom headers here if needed
          // 'Accept': 'application/json, text/plain, */*',
          // 'Referer': 'https://rezrewardspython.secretdemo.com/rezlive',
          // 'User-Agent': 'Mozilla/5.0 ...'
        },
      });
      const url = URL.createObjectURL(response.data);
      this.setState({ qrCodeUrl: url });
    } catch (e) {
      this.setState({ qrCodeUrl: "" });
    }
  };

  render() {
    const {
      contactUs,
      AppTitle,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      userDetails,
      isShowChangeLanguageModalPopUp,
      currentLanguage,
    } = this.state;
    const {
      handleNotificicationDrawer,
      isRegisterAllow,
      headerCounters,
    } = this.props;
    const { isInquiry } = this.props;

    const strMyWishlist =
      getValueFromLanguageObject("str_my_wishlist") || "My Wishlist";

    return (
      <>
        <div
          style={{ backgroundColor: getColorCodeBasedOnKey("bg_top_header") }}
          className="top-header border-bottom border-gray"
        >
          <div
            className="header_container flex items-center px-3 py-2 h-auto"
            style={{ width: "100%" }}
          >
            {/* Logo and search */}
            <div className="header_left d-flex flex-column flex-md-row items-center flex-xl-nowrap align-items-center justify-content-start">
              {/* Logo */}
              <a
                href="/rezlive"
                className="flex items-center"
                style={{ minWidth: "160px", marginRight: "0" }} // <-- Remove margin between logo and search bar
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/logo.svg`}
                  alt="logo"
                  className="rounded-full"
                  style={{
                    background: "transparent",
                    width: "150px",
                    boxShadow: "none",
                  }}
                />
                <span className="font-bold text-xl text-gray-800 ml-2">
                  {AppTitle}
                </span>
              </a>

              {/* Search Bar - wide and inline */}
              <div className="mx-4 w-100" style={{ maxWidth: "600px" }}>
                {/* Show search bar only if user is logged in */}
                {userDetails && (
                  <div style={{ fontSize: "13px" }}>
                    {" "}
                    {/* Decrease font size */}
                    {this.renderSearchBar()}
                  </div>
                )}
              </div>
            </div>
            {/* Right-side icons */}
            <div className="header_right flex items-center justify-end">
              {" "}
              {/* move icons a bit left */}
              <ul className="header-dropdown d-flex align-items-center space-x-2 m-0 flex-nowrap mobile-fixed">
                {/* Download App Button */}
                <li className="cart_sign_in mobile-menu download-app p-0">
                  <button
                    type="button"
                    className="btn border-0 d-flex align-items-center justify-content-center fw-bold text-white"
                    style={{ background: "#FF6A00" }}
                    onClick={this.handleDownloadAppClick}
                  >
                    <i
                      className="fa fa-download mr-2 d-inline d-lg-none text-white"
                      aria-hidden="true"
                    />
                    <span className="d-none d-lg-inline">Download App</span>
                  </button>
                </li>
                {/* Reward Points, Cart, Compare, Wishlist, Notifications - show only if userDetails exists */}
                {userDetails && (
                  <>
                    <li className="cart_sign_in mobile-menu reward">
                      <Link
                        to="/rewardpoints"
                        className="block cursor-pointer"
                        title={`Benefits: 1 Point = 1 INR`}
                      >
                        <div className="d-flex align-items-center">
                          {/* <i className="fa fa-gift mr-md-1 text-yellow-500" style={{ fontSize: "24px" }} /> */}
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/images/giftbox.png`}
                            alt="Gift"
                            style={{
                              height: "32px",
                              width: "32px",
                              marginRight: "8px",
                            }}
                          />

                          {/* Remove the title, show only points */}
                          <span className="text-primary d-xl-inline d-none">
                            {headerCounters.reward_points + " Points"}
                          </span>
                        </div>
                      </Link>
                    </li>
                    {/* Cart */}
                    <li className="cart_sign_in mobile-menu cart relative">
                      <CartContainer />
                      {headerCounters.cart_count > 0 && (
                        <span className="cart-qty-cls absolute top-0 right-0 bg-red-500 text-white rounded-full px-2 text-xs">
                          {headerCounters.cart_count}
                        </span>
                      )}
                    </li>

                    {/* Compare */}
                    <li className="cart_sign_in mobile-menu compare relative">
                      <CompareContainer />
                      {headerCounters.comparison_count > 0 && (
                        <span className="cart-qty-cls absolute top-0 right-0 bg-blue-500 text-white rounded-full px-2 text-xs">
                          {headerCounters.comparison_count}
                        </span>
                      )}
                    </li>

                    {/* Wishlist */}
                    <li className="cart_sign_in mobile-menu relative wishlist-icon">
                      <Link to="/wishlist" className="flex items-center">
                        {/* <i className="fa fa-heart text-pink-500 text-lg" /> */}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2351_15)">
                            <path
                              d="M223.75 64.9373C229.724 70.5541 235.098 76.4101 240 82.9998C240.416 83.557 240.832 84.1142 241.261 84.6883C255 103.178 255 103.178 255 108C255.66 108 256.32 108 257 108C257.236 107.158 257.472 106.316 257.715 105.449C259.198 101.467 261.176 98.3026 263.562 94.8123C264.008 94.1544 264.453 93.4966 264.912 92.8189C268.952 86.9307 273.307 81.3836 278 75.9998C278.853 75.0124 279.707 74.0249 280.586 73.0076C300.341 50.5661 328.619 32.6124 359 29.9998C359.693 29.9356 360.386 29.8715 361.101 29.8054C397.311 26.6323 432.43 35.9733 460.647 59.3655C484.483 79.88 500.091 105.856 507.812 136.25C508.007 137.016 508.202 137.783 508.403 138.573C511.297 150.682 512.352 162.669 512.316 175.076C512.312 177.3 512.336 179.523 512.361 181.748C512.421 195.199 510.433 208.188 506.687 221.125C506.474 221.87 506.26 222.615 506.04 223.383C497.857 251.117 482.284 275.84 464 298C463.548 298.55 463.095 299.1 462.629 299.666C451.874 312.69 440.32 324.847 428.365 336.765C426.301 338.823 424.243 340.887 422.186 342.951C420.849 344.287 419.513 345.622 418.176 346.957C417.573 347.561 416.971 348.165 416.351 348.788C412.63 352.488 408.79 355.999 404.814 359.424C402.038 361.836 399.369 364.359 396.687 366.875C392.751 370.543 388.765 374.072 384.562 377.437C380.187 380.946 376.08 384.658 372 388.5C367.021 393.187 361.918 397.612 356.578 401.89C353.976 404.02 351.484 406.234 349 408.5C344.7 412.419 340.241 416.091 335.719 419.75C332.221 422.645 328.882 425.696 325.527 428.754C322.93 431.062 320.266 433.255 317.562 435.437C313.759 438.513 310.099 441.687 306.5 445C302.03 449.114 297.41 452.971 292.684 456.785C290.053 458.956 287.521 461.202 285 463.5C279.826 468.205 274.473 472.648 269 477C268.339 477.541 267.677 478.083 266.996 478.64C263.054 481.709 259.999 482.911 255 483C249.525 481.866 246.008 479.828 241.937 476.125C240.799 475.126 239.661 474.127 238.523 473.129C237.943 472.612 237.363 472.095 236.765 471.563C233.898 469.023 230.977 466.547 228.062 464.062C226.885 463.052 225.708 462.042 224.531 461.031C222.2 459.029 219.866 457.029 217.531 455.031C210.869 449.33 204.23 443.605 197.608 437.858C191.671 432.708 185.705 427.593 179.734 422.484C176.821 419.991 173.911 417.495 171 415C169.833 414 168.667 413 167.5 412C165.167 410 162.833 408 160.5 406C159.922 405.505 159.345 405.01 158.749 404.5C157.584 403.501 156.419 402.501 155.254 401.502C152.318 398.983 149.378 396.469 146.43 393.965C139.72 388.255 133.14 382.438 126.672 376.457C123.813 373.828 120.904 371.269 117.973 368.722C104.641 357.081 91.7809 344.968 79.269 332.454C77.2433 330.431 75.2097 328.415 73.1757 326.4C65.9802 319.235 59.2821 311.987 53 304C52.0543 302.886 51.1012 301.777 50.1367 300.679C20.2384 266.442 -0.543661 223.887 -0.312545 177.875C-0.31039 177.102 -0.308234 176.33 -0.306014 175.534C-0.253483 163.79 0.202599 152.455 2.99996 141C3.28999 139.77 3.28999 139.77 3.58589 138.515C9.91325 112.39 21.8172 89.73 40 69.9998C40.7373 69.1799 41.4746 68.3601 42.2343 67.5154C91.0946 15.7162 173.343 18.6031 223.75 64.9373ZM72 82.9998C71.1724 83.6636 70.3448 84.3275 69.4921 85.0115C48.0567 103.188 34.1926 131.852 31.1677 159.652C29.9098 177.257 30.1299 194.958 35 212C35.193 212.697 35.386 213.395 35.5849 214.113C43.2254 240.761 59.7742 264.499 78 285C79.1666 286.354 80.3333 287.708 81.5 289.062C89.6122 298.241 97.966 307.132 106.644 315.774C108.201 317.326 109.752 318.882 111.303 320.439C116.135 325.275 121.011 330.008 126.21 334.455C129.162 337.003 131.976 339.699 134.812 342.375C139.767 347.017 144.853 351.382 150.156 355.625C153.556 358.464 156.776 361.464 160 364.5C164.979 369.187 170.082 373.612 175.422 377.89C178.024 380.02 180.516 382.234 183 384.5C186.417 387.614 189.905 390.592 193.5 393.5C197.963 397.11 202.227 400.884 206.469 404.75C209.088 407.078 211.775 409.295 214.5 411.5C218.963 415.11 223.227 418.884 227.469 422.75C230.969 425.861 234.613 428.782 238.254 431.726C241.876 434.725 245.347 437.873 248.809 441.054C250.803 442.825 252.841 444.436 255 446C263.575 442.191 270.609 434.502 277.469 428.25C280.978 425.13 284.632 422.202 288.281 419.25C290.921 417.065 293.467 414.808 296 412.5C300.3 408.581 304.759 404.908 309.281 401.25C311.921 399.065 314.467 396.808 317 394.5C321.3 390.581 325.759 386.908 330.281 383.25C333.783 380.351 337.126 377.297 340.484 374.234C343.013 371.988 345.61 369.864 348.25 367.75C354.009 363.093 359.379 358.071 364.777 353.008C367.827 350.149 370.944 347.38 374.105 344.644C378.124 341.156 382.066 337.583 386 334C386.762 333.307 386.762 333.307 387.54 332.601C396.247 324.666 404.661 316.444 413 308.125C413.495 307.633 413.989 307.141 414.499 306.634C420.22 300.936 425.77 295.154 431 289C431.869 288.012 432.738 287.025 433.633 286.008C453.305 263.252 470.377 237.384 478 208C478.318 206.846 478.637 205.692 478.965 204.504C486.044 174.197 480.721 139.26 465.098 112.359C461.724 106.957 458.034 101.925 454 96.9998C452.971 95.7236 452.971 95.7236 451.922 94.4216C434.615 74.0386 410.073 62.5731 383.633 60.4094C358.017 58.6471 334.876 66.7193 315 82.9998C314.198 83.6482 313.396 84.2966 312.57 84.9646C306.59 90.0242 301.769 95.8062 297 102C296.331 102.853 295.662 103.706 294.973 104.586C284.874 117.904 277.549 132.94 271.668 148.531C268.687 156.328 268.687 156.328 265.25 159.687C259.601 161.969 254.566 163.003 248.75 160.687C243.714 157.727 242.105 153.246 240 148C239.463 146.674 238.925 145.348 238.387 144.023C237.957 142.965 237.957 142.965 237.519 141.885C237.224 141.16 236.929 140.434 236.625 139.687C236.177 138.583 236.177 138.583 235.72 137.457C229.376 122.011 220.544 107.28 209.008 95.1482C207 92.9998 207 92.9998 205.059 90.4998C190.425 72.728 166.006 62.7372 143.656 60.2615C117.554 58.393 92.2749 66.483 72 82.9998Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2351_15">
                              <rect width="512" height="512" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        {headerCounters.wishlist_count > 0 && (
                          <span className="cart-qty-cls absolute top-0 right-0 bg-pink-500 text-white rounded-full px-2 text-xs">
                            {headerCounters.wishlist_count}
                          </span>
                        )}
                      </Link>
                    </li>
                  </>
                )}
                {/* My Account - hide when not logged in on /login */}
                {!(this.state.userDetails === undefined &&
                  this.props.location &&
                  this.props.location.pathname === "/login") && (
                  <li className="cart_sign_in mobile-menu account relative">
                  <div
                    className="dropdown-toggle cursor-pointer d-flex align-items-center space-x-2 hover:bg-gray-100 px-2 py-1 rounded-full transition"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {/* <i className="fa fa-user-circle text-2xl mr-xl-1 text-white d-lg-none" />
                    <i className="fa fa-user-circle text-2xl mr-xl-1 d-none d-lg-inline" /> */}
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 44 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28.7886 2.14828C28.8462 2.16739 28.9039 2.1865 28.9633 2.20618C31.9482 3.2089 34.5382 4.94906 36.7808 7.13265C36.8612 7.20964 36.9416 7.28664 37.0245 7.36596C37.5301 7.85831 37.9776 8.38301 38.4136 8.93734C38.4816 9.02109 38.5496 9.10484 38.6197 9.19112C40.0421 10.977 41.117 13.0547 41.8511 15.2108C41.8749 15.2802 41.8987 15.3495 41.9232 15.421C43.6942 20.6828 43.1802 26.4517 40.7624 31.4147C39.8144 33.3047 38.5881 35.0003 37.1245 36.5233C37.0758 36.5744 37.027 36.6255 36.9768 36.6781C36.2876 37.3968 35.5802 38.0578 34.7787 38.6495C34.6357 38.7551 34.4944 38.8627 34.353 38.9705C30.0466 42.2016 24.4624 43.4593 19.1636 42.7967C14.7515 42.1654 10.6872 40.2107 7.47609 37.1248C7.42499 37.0761 7.37389 37.0273 7.32125 36.9771C6.55634 36.2436 5.87074 35.4851 5.24171 34.6327C5.16977 34.5375 5.09782 34.4424 5.02586 34.3473C3.66464 32.522 2.65485 30.4417 1.97609 28.2733C1.95584 28.209 1.9356 28.1447 1.91474 28.0785C0.26255 22.7365 0.96238 16.9751 3.51759 12.0418C3.903 11.3177 4.33548 10.6357 4.81202 9.96859C4.85121 9.91313 4.8904 9.85767 4.93078 9.80053C5.56977 8.90169 6.27716 8.09353 7.0464 7.30453C7.13078 7.21669 7.21515 7.12885 7.29951 7.04101C7.81483 6.51321 8.35682 6.04058 8.93702 5.58578C9.06248 5.48392 9.06248 5.48392 9.19047 5.38C14.6405 1.03777 22.2439 -0.0647434 28.7886 2.14828ZM16.4136 10.1405C16.3132 10.2304 16.3132 10.2304 16.2108 10.3221C14.7518 11.6981 13.804 13.7257 13.729 15.7335C13.681 18.2032 14.4054 20.2932 16.1081 22.1219C17.6577 23.6963 19.8103 24.5394 22.0032 24.5813C24.0037 24.5736 25.8995 23.8038 27.4136 22.5155C27.5008 22.447 27.5008 22.447 27.5898 22.3772C29.1015 21.1533 29.993 19.1656 30.2495 17.2733C30.2732 16.9505 30.2783 16.63 30.2764 16.3065C30.2757 16.1771 30.2757 16.1771 30.2749 16.0451C30.2357 13.6265 29.1753 11.7031 27.4861 10.0445C25.7981 8.48788 23.597 7.91379 21.3549 7.98032C19.5374 8.0794 17.7454 8.92384 16.4136 10.1405ZM9.663 31.913C9.10112 32.5523 8.43215 33.3945 8.16359 34.203C8.62909 35.4002 10.2421 36.4059 11.2573 37.1248C11.3111 37.1635 11.3649 37.2021 11.4203 37.2418C15.3481 40.0426 20.3478 41.0854 25.0819 40.3106C28.8197 39.6512 32.1623 37.9493 34.8901 35.3202C34.9822 35.2345 35.0743 35.1489 35.1664 35.0634C35.2553 34.979 35.344 34.8945 35.4326 34.8099C35.5518 34.6971 35.5518 34.6971 35.6733 34.582C35.8534 34.3964 35.8534 34.3964 35.8334 34.205C34.609 31.6679 32.3813 29.7635 29.7575 28.7904C28.4751 28.3447 27.1414 28.1751 25.7894 28.1735C25.7 28.1731 25.6105 28.1726 25.5184 28.1722C25.2248 28.171 24.9313 28.1704 24.6377 28.1699C24.5365 28.1696 24.4352 28.1694 24.3309 28.1692C23.7945 28.1679 23.258 28.1671 22.7216 28.1667C22.1725 28.1662 21.6234 28.1642 21.0743 28.1617C20.6477 28.1601 20.2212 28.1597 19.7946 28.1595C19.5925 28.1593 19.3903 28.1586 19.1882 28.1575C15.451 28.1379 12.2598 29.1112 9.663 31.913Z"
                        fill="black"
                      />
                    </svg>
                    <span className="d-none d-xl-inline ml-2">
                      {getValueFromLanguageObject("str_my_account") ||
                        "My Account"}
                    </span>
                  </div>

                  {/* Account Dropdown Options */}
                  {this.state.isMyAccountVisible ? (
                    <div className="usesr_dropsowdropdown dropdown-menu right-0 mt-2 rounded-xl shadow-xl bg-white p-3 min-w-[180px]">
                      <Link
                        to={`/login`}
                        className="dropdown-item block px-4 py-2 rounded hover:bg-blue-50 text-gray-900"
                      >
                        {getValueFromLanguageObject("str_login") || "Login"}
                      </Link>
                      {isRegisterAllow && (
                        <Link
                          to={`/signup`}
                          className="dropdown-item block px-4 py-2 rounded hover:bg-blue-50 text-gray-700"
                        >
                          {getValueFromLanguageObject("str_register") ||
                            "Register"}
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div className="usesr_dropsowdropdown dropdown-menu mt-2 rounded-xl shadow-xl bg-white p-3 min-w-[200px] flex flex-col space-y-1">
                      <Link
                        to="/myprofile" // <-- change from "#" to "/myprofile"
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-user-circle-o mr-2 text-blue-500" />
                        {getValueFromLanguageObject("str_my_profile") ||
                          "My Profile"}
                      </Link>
                      <Link
                        to={`/address`}
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-address-book mr-2 text-green-500" />
                        Address Book
                      </Link>
                      <Link
                        to={`/orders`}
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-list-alt mr-2 text-purple-500" />
                        {!isInquiry
                          ? getValueFromLanguageObject("my_orders") ||
                            "Order History"
                          : getValueFromLanguageObject("str_my_inquiries") ||
                            "My Inquiries"}
                      </Link>
                      <Link
                        to={`/wishlist`}
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-heart mr-2 text-pink-500" />
                        {strMyWishlist}
                      </Link>
                      <Link
                        to={`/rewardpoints`}
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-star mr-2 text-yellow-500" />
                        Reward Points
                      </Link>
                      {/* NEW: Downloads */}
                      <Link
                        to={`/downloads`}
                        className="dropdown-item flex items-center px-4 py-2 rounded hover:bg-yellow-100 text-gray-700"
                      >
                        <i className="fa fa-download mr-2 text-indigo-500" />
                        Downloads
                      </Link>
                      <div
                        onClick={() => {
                          this.logout();
                        }}
                        className="dropdown-item text-red-500 cursor-pointer text-center px-4 py-2 rounded hover:bg-red-100 font-semibold"
                      >
                        Logout
                      </div>
                    </div>
                  )}
                </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Error & Success Modals */}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}

        {/* QR Code Modal - NEW */}
        {this.state.showQrModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.5)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => this.setState({ showQrModal: false })}
          >
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 12,
                minWidth: 320,
                textAlign: "center",
                position: "relative",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4 style={{ marginBottom: 16 }}>Download Our App</h4>
              <p style={{ marginBottom: 16 }}>
                Scan this QR code to download our app.
                <br />
                You can also{" "}
                <a
                  href="https://your-app-download-link.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  click here
                </a>{" "}
                to download directly.
              </p>
              {this.state.qrCodeUrl ? (
                <img
                  src={this.state.qrCodeUrl}
                  alt="QR Code"
                  style={{
                    width: 180,
                    height: 180,
                    marginBottom: 16,
                  }}
                />
              ) : (
                <p>Loading QR code...</p>
              )}
              <button
                className="btn btn-solid"
                style={{ marginTop: 16 }}
                onClick={() => this.setState({ showQrModal: false })}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isRegisterAllow: state.settings.isRegisterAllow,
  isInquiry: state.settings.isInquiry,
  notificationCounter: state.cartCounter.notificationCounter,
  compareCounter: state.compare.items.length,
  headerCounters: state.headerCounters, // <-- get from Redux
});

export default connect(mapStateToProps, {
  isUserAllowedToRegister: isUserAllowedToRegister,
  isInquiryOrCart: isInquiryOrCart,
  setHeaderCounters, // <-- add this
})(withTranslate(withRouter(TopBar)));
